module.exports = __webpack_public_path__ + "img/info_Card2.4088b3a5.png";